import axios from "axios";
import Cookies from "js-cookie";

let Service = axios.create({
    baseURL: 'https://api.barbersunity.com',
});
//https://api.barbersunity.com
//http://localhost:4000
Service.interceptors.request.use((request) => {
    let token = Auth.getToken();
    if (token) {
        request.headers["Authorization"] = "Bearer " + token;
    }
    return request;
});

let Auth = {
    async login(email, password) {
        let response = await Service.post("/authuser", {
            email: email,
            password: password,
        });
        let user = response.data;
        Cookies.set('user', JSON.stringify(user), { expires: 365, domain: '.barbersunity.com' });
        return true;
    },
    logout() {
    Cookies.remove('user', { domain: '.barbersunity.com' });
    localStorage.removeItem('data'); 
    window.location.href = '/';
},
    getUser() {
        const user = Cookies.get('user');
        return user ? JSON.parse(user) : null;
    },
    getToken() {
        let user = Auth.getUser();
        return user && user.token ? user.token : false;
    },
    authenticated() {
        let user = Auth.getUser();
        return user && user.token ? true : false;
    },
    state: {
        get authenticated() {
            return Auth.authenticated();
        }
    }
}

async function getSubscriptionStatus() {
  return Service.get('/subscription/status')
}

async function createCheckoutSession() {
  return Service.post('/subscription/create-checkout-session')
}

async function cancelSubscription() {
  return Service.post('/subscription/cancel')
}

export { Auth, Service, getSubscriptionStatus, createCheckoutSession, cancelSubscription }
